<script setup lang="ts">
import { DateTime } from 'luxon'
import { useI18n } from 'vue-i18n'
import { useMainStore } from '~/store/MainStore'
import ThemeSelector from '~/components/User/ThemeSelector.vue'

const { rootData } = storeToRefs(useMainStore())
const { t } = useI18n()
const footerLine = computed(() => {
  return `©${DateTime.now().toFormat('yyyy')} ${rootData.value.name}`
})
</script>

<template>
  <footer class="w-full border-t border-tw-1 py-4 text-sm bg-tw-2">
    <div class="tw-container text-tw-1">
      <div class="w-full flex flex-row items-center justify-between">
        <div>
          {{ footerLine }}<span class="opacity-40 cursor-not-allowed"> | {{ t('PRIVACY') }}</span>
        </div>
        <div>
          <ClientOnly>
            <theme-selector />
          </ClientOnly>
        </div>
      </div>
    </div>
  </footer>
</template>
